import MemberRequest from "../../MemberRequest";

function getResult(data) {
  let res=false;
  if (data.hasOwnProperty("getProfile")) {
    res = data.getProfile;
  }
  return res;
}

const sendGetProfile = async function () {
  let res=false;
  let req=new MemberRequest();
  req.query='{getProfile{firstName,lastName,username,email,nationalCode,address,birthAt,job,jobaddress}}';
  res = await req.send(getResult);
  return res;
};

export default async function getProfile() {
  return await sendGetProfile();
}
